import { newEl, child, upTo, setClass } from "./dom.js";
import Ribbon from "./ribbon.js";
import blankCells from "./puzzle-generation/blank-cells.js";
import { calculateRibbons } from "./puzzle-generation/ribbon-pattern.js";
import { straightCentre, diagCentre, straightCorner, diagCorner, fortyFive } from "./svg.js";

const container = document.getElementById('container');

export default class Grid {
	constructor(w, h) {
		this.w = w;
		this.h = h;
		this.el = newEl("div.grid");
		this.cells = blankCells(w, h);
		for (let y = 0; y < h * 2; ++y)
			for (let x = 0; x < w * 2; ++x) {
				const cell = this.cells[y][x];
				cell.td = child(this.el, "div");
				cell.td.dataset.x = x;
				cell.td.dataset.y = y;
				cell.container = child(cell.td, "div.ribbon-images");
				cell.td.classList.add(cell.xParity ? "x-even" : "x-odd");
				cell.td.classList.add(cell.yParity ? "y-even" : "y-odd");
			}
		this.updateListeners = [];
		this.update(false);
	}

	toggleWall(x, y, direction) {
		if (x < 1 || y < 1 || x >= this.cells[0].length || y >= this.cells.length) return;
		const cell = this.cells[y][x],
			cellAbove = this.cells[y - 1][x],
			cellLeft = this.cells[y][x - 1];
		if (direction) {
			if (cell.hWall) {
				cell.hWall = cellLeft.hWall = false;
				cell.vWall = cellAbove.vWall = true;
			} else if (cell.vWall)
				cell.vWall = cellAbove.vWall = false;
			else
				cell.hWall = cellLeft.hWall = true;
		} else {
			if (cell.vWall) {
				cell.vWall = cellAbove.vWall = false;
				cell.hWall = cellLeft.hWall = true;
			} else if (cell.hWall)
				cell.hWall = cellLeft.hWall = false;
			else
				cell.vWall = cellAbove.vWall = true;
		}
		this.update(true);
	}

	*allCells() {
		for (const row of this.cells) yield *row;
	}

	onUpdate(callback) {
		this.updateListeners.push(callback);
	}

	update(...args) {
		this.ribbons = calculateRibbons(this.cells).map(cells => new Ribbon(cells));
		this.render();
		for (const listener of this.updateListeners) listener(...args);
	}

	render() {
		for (const { container, td, vWall, hWall } of this.allCells()) {
			setClass(td, "v-wall", vWall);
			setClass(td, "h-wall", hWall);
			container.innerHTML = "";
		}
		for (const { x, y, next, previous, ribbon, container } of this.allCells())
			tileImages(container, previous, { x, y }, next, this.cells, this.ribbons[ribbon]);
	}
}

function tf(el) {
	const tf = el.style.transform;
	if (!tf || tf == "none") return 0;
	if (tf.startsWith("rotate(")) return (tf.replace(/^rotate\((-?[\d.]+)deg\)$/, "$1") / 90 + 400) % 4;
	return tf;
}

// 1 2 3
// 4 * 6
// 7 8 9
function clock(x, y) { return y * 3 + x + 5; }
function tileImages(container, previous, { x, y }, next, allCells, ribbon) {
	let d1 = clock(previous.x - x, previous.y - y),
		d2 = clock(next.x - x, next.y - y);
	if (d1 > d2) [d1, d2] = [d2, d1];
	// Draw the main image:
	// ribbon.addImage(child(container, "img.main", options(d1, d2)));
	ribbon.addImage(createImage(container, `${d1}-${d2}`));
	// Add in any extra corners. We're only going to do the corners above us — the corners below us should get filled in by the tiles below.
	if (d1 == 1) {
		ribbon.addImage(createImage(allCells[y - 1][x].container, "d1y"));
		ribbon.addImage(createImage(allCells[y][x - 1].container, "d1x"));
	} else if (d1 == 3) {
		ribbon.addImage(createImage(allCells[y - 1][x].container, "d3y"));
		ribbon.addImage(createImage(allCells[y][x + 1].container, "d3x"));
	}
}

function createImage(parent, type) {
	const container = child(parent, `div.img-${type}`);
	switch(type.split('.')[0]) {
		case "d1x": case "d3x": case "d1y": case "d3y": diagCorner(container); break;
		case "2-8": case "4-6": straightCentre(container); break
		case "1-9": case "3-7": diagCentre(container); break;
		case "4-8": case "6-8": case "2-6": case "2-4": straightCorner(container); break;
		case "4-9":  case "3-8":  case "1-6":  case "2-7":  case "3-4":  case "1-8":  case "6-7":  case "2-9": fortyFive(container); break;
		default:
			console.error({ d1, d2, previous, current: { x, y }, next });
			throw new Error("Unexpected directions: " + d1 + ", " + d2);
	}
	return container;
}
